import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import 'jquery';
import 'bootstrap/dist/js/bootstrap';

import 'normalize.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';

import "./misc/utils/extensions";
import "./misc/utils/utils";
import components from './components/components';
import filters from "./misc/filters/filters";
import services from "./misc/services/services";
import directives from "./misc/directives/directives";

import './app.style.scss';
import template from './app.template.html';
import controller from './app.controller';
import favicon from "assets/img/faviconCooper.ico";

/*var history_api = typeof history.pushState !== 'undefined';
if ( history_api ) history.pushState(null, '', 'senhaop/#/');*/

/**
 * Main App Component
 * Register base component to bootstrap entire app
 */
angular.module('app', [uiRouter, filters, services, components, directives])
	.config(($locationProvider, $urlRouterProvider, $stateProvider) => {
		"ngInject";
		// @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions#how-to-configure-your-server-to-work-with-html5mode
		$locationProvider.html5Mode(false).hashPrefix('');
	})

	.component('app', {
		template,
		controller
	});


// WEBPACK FOOTER //
// ./src/app/app.js